import { api, ChatMessage } from '../api';
import { compressImage, mediaDuration, videoPoster } from './compress';
import type { Draft } from './outbox';

/*
 * Отправка одного черновика: то, что раньше делал цикл внутри Composer.send.
 * Вынесено отдельно, чтобы очередь в провайдере оставалась про состояние, а
 * не про сеть, и чтобы саму отправку можно было проверить без React.
 */

export type SendHandlers = {
  /** Начался файл с этим номером, считая с нуля. */
  begin: (index: number) => void;
  /** Ход текущего файла, 0…100. */
  progress: (pct: number) => void;
};

export async function sendDraft(draft: Draft, on: SendHandlers): Promise<ChatMessage> {
  // файлы уходят по очереди: порядок загрузки задаёт порядок в сетке
  const fileIds: number[] = [];
  for (let i = 0; i < draft.files.length; i += 1) {
    on.begin(i);
    // фотографии пережимаем: снимок с телефона весит в разы больше нужного
    const f = await compressImage(draft.files[i].file);
    const isVideo = f.type.startsWith('video/');
    const isAudio = f.type.startsWith('audio/');
    const duration = isVideo || isAudio ? await mediaDuration(f) : 0;
    const uploaded = await api.chatUpload(draft.channelId, f, {
      // у голосового длительность и форма волны сняты при записи, считать нечего
      duration: draft.voice ? draft.voice.seconds : duration,
      waveform: draft.voice?.waveform,
      onProgress: (fraction) => on.progress(Math.round(fraction * 100)),
    });
    fileIds.push(uploaded.id);
    if (isVideo) {
      const poster = await videoPoster(f);
      if (poster) await api.chatSetPoster(draft.channelId, uploaded.id, poster);
    }
  }
  return api.chatPost(draft.channelId, {
    text: draft.text,
    parentId: draft.parentId ?? undefined,
    fileIds,
    replyToId: draft.replyToId,
  });
}
